import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {
  DROPDOWN_ANIMATION_E_TO_TOP_L_TO_BOTTOM,
  HEIGHT_SMOOTH_ANIMATION,
  RIGHT_TO_LEFT_NOTIFICATION_SHOW
} from "../../../animations";

@Component({
  selector: 'int-default-notification',
  templateUrl: './int-default-notification.component.html',
  styleUrls: ['./int-default-notification.component.scss'],
  changeDetection :ChangeDetectionStrategy.OnPush,
  animations: [
    RIGHT_TO_LEFT_NOTIFICATION_SHOW({duration: 0.2, timingFunction: 'ease'})
  ]
})
export class IntDefaultNotificationComponent implements OnInit {

  @HostBinding('attr.data-test-element')
  @Input() mode: 'info' | 'danger' | 'success' | 'warning' = 'info';

  @Input() title: string | null = null;
  @Input() description: string | null = null;
  @Input() addedDescription: string | null = null;
  @Input() closeFn: () => void = () => undefined;

  @Input() template: TemplateRef<any> | null = null
  @Input() templatePayload!: Object | null;

  constructor(private host: ViewContainerRef, private renderer: Renderer2) { }

  @HostBinding('@rightToLeftNotificationShow') get animation() {
    return true
  }

  ngOnInit(): void {
    this.renderer.addClass(this.host.element.nativeElement, this.modify);
  }

  get modify() {
    return `int-${this.mode}`;
  }

  get isDivider(): boolean {
    return !!(this.title && this.description);
  }

}
